module.exports = __webpack_public_path__ + "img/GU.59fc2459.svg";